import { Reveal, MaskedHeading, ParallaxImage } from "../Reveal";
import { BETWEEN, IMAGES } from "../../data/content";

export default function BetweenEvenings() {
  return (
    <section
      className="section bg-pearl text-abyss py-24 md:py-40"
      data-testid="between-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num text-turquoise">CHAPITRE 05 — ENTRE LES SOIRÉES</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.2rem,4.8vw,4rem)] leading-tight tracking-tight text-abyss mt-8 max-w-4xl"
          lines={["L'expérience ne s'arrête pas", "lorsque l'écran s'éteint"]}
        />

        <div className="grid lg:grid-cols-12 gap-10 mt-12">
          <Reveal className="lg:col-span-5 space-y-5 text-abyss/75 text-lg leading-relaxed">
            <p>
              Entre les trois grandes soirées, tu recevras des propositions simples pour
              laisser l'expérience descendre dans ta vie.
            </p>
            <p>
              Pas de devoirs interminables. Pas de programme militaire de transformation
              personnelle. Pas vingt-sept vidéos à rattraper en culpabilisant le dimanche
              soir.
            </p>
            <p className="font-display italic text-2xl text-abyss">
              Des expériences brèves, précises et incarnées, à vivre à ton rythme.
            </p>
          </Reveal>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-abyss/10 rounded-sm overflow-hidden">
            {BETWEEN.map((b, i) => (
              <Reveal key={b.title} delay={i * 0.07} className="bg-pearl p-7 flex flex-col gap-3">
                <h3 className="font-display text-xl md:text-2xl text-abyss leading-tight">
                  {b.title}
                </h3>
                <p className="text-abyss/70 text-[0.92rem] leading-relaxed">{b.text}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.05} className="mt-14">
          <ParallaxImage
            src={IMAGES.group}
            alt="Petit groupe d'adultes réunis au bord de la mer à la lumière dorée"
            className="aspect-[16/9] md:aspect-[21/8] rounded-sm"
            amount={50}
          />
        </Reveal>

        <Reveal delay={0.1} className="mt-16 max-w-3xl border-t border-abyss/10 pt-8">
          <p className="font-display text-xl md:text-2xl leading-snug text-abyss/85">
            Tu n'auras pas besoin de partir dans une grotte, de porter du lin blanc ni de
            parler aux mouettes. Seulement d'être un peu plus présent à ce que tu vis.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
